import { useRef, useState, useEffect, React } from "react";
import { useBlogContext } from "../../fetchdata/BlogContext";
import Header from "../components/Header"; // Replace this with your Header component
import Footer from "../components/Footer";
import { Link, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-hot-toast";
import axios from "axios";
import { Swiper, SwiperSlide } from "swiper/react";
import axiosInstance from '../../axiosInstance';
// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";

// import required modules
import { Pagination, Navigation, Autoplay } from "swiper/modules";
import { Helmet } from "react-helmet";
import HeaderPage from "../components/HeaderPage";
import NavBar from "../components/NavBar";

const Category = () => {

  const swiperRefLocal = useRef();

  const handleMouseEnter = () => {
    swiperRefLocal?.current?.swiper?.autoplay?.stop();
  };

  const handleMouseLeave = () => {
    swiperRefLocal?.current?.swiper?.autoplay?.start();
  };


  const [layout, setLayout] = useState([]);

  const [isLoading, setIsLoading] = useState(true);

  const [isProducts, setIsProducts] = useState(true);

  const [RProducts, setRProducts] = useState([]);


  const getProducts = async () => {
    try {
      const { data } = await axiosInstance.get("/all-home-products");
      setRProducts(data.products);
      setIsProducts(false); // Set loading state to false in case of an error
    } catch (error) {
      console.error("Error fetching products:", error);
      setIsProducts(false); // Set loading state to false in case of an error
    }
  };

  const getData = async () => {
    try {
      const { data } = await axiosInstance.get(`/home-layout-data`);
      setLayout(data.homeLayout);
      setIsLoading(false); // Set loading state to false in case of an error
    }
    catch (error) {
      console.log(error);
      toast.error("Error fetching Home layout!");
      setIsLoading(false); // Set loading state to false in case of an error
    }
  };

  useEffect(() => {
    getData();
    getProducts();
  }, []);





  const startMin = 0;
  const startMax = 100;
  const min = 0;
  const max = 200;
  const step = 1;

  const [selectedRanges, setSelectedRanges] = useState([]);

  const [selectedFilters, setSelectedFilters] = useState({});
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [Cat, setCat] = useState([]);
  const [CatT, setTCat] = useState("");
  const [CatImage, setTCatImage] = useState("");

  const [CatM, setMCat] = useState([]);

  const [Pro, setPro] = useState([]);
  const [Attr, setAttr] = useState([]);
  const [fillter, setfillter] = useState('');

  const [Viewfillter, setViewfillter] = useState([]);


  const [isCat, setIsCat] = useState(true);
  const [count, setcount] = useState('100');
  const [Sidebar, setIsSidebar] = useState(false);



  const handlecountChange = (event) => {
    setcount(event.target.value);
  };

  const { id } = useParams();
  const [products, setProducts] = useState([]);
  const [ratings, setRatings] = useState([]);


  const getRating = async () => {
    try {
      const { data } = await axiosInstance.get(`/all-rating`);
      setRatings(data.ratings);
      // console.log('getRating', data)

    } catch (error) {
      console.error("Error fetching rating:", error);
    }
  };

  const getCategory = async (fillter, page, price) => {
    setIsSidebar(false)
    try {
      window.scrollTo(0, 0);
      setIsCat(true);
      const encodedFilter = encodeURIComponent(fillter); // Encode the filter string

      const { data } = await axiosInstance.get(`/all/category-slug/${id}?filter=${encodedFilter}&price=${price}&page=${page}&perPage=${count}`);
      setCat([]);
      setTCat("");
      setMCat([])
      if (data?.success) {
        setCat(data?.categories);
        setTCat(data.MainCat.title);
        setTCatImage(data.MainCat.image)
        setTotalPages(data?.proLength);
        setfillter(fillter);

        setProducts(data?.productsFilter);

        setPro(data?.products);
        setMCat(data?.MainCat)
      }

      // console.log('datadatadata', data)
    } catch (error) {
      console.log(error);
      toast.error("Error fetching Category!");
    } finally {
      setIsCat(false);
    }
  };

  const Opensidebar = async () => {
    setIsSidebar(true)
  }
  const Closesidebar = async () => {
    setIsSidebar(false)
  }

  const getAttribute = async () => {
    try {
      const { data } = await axiosInstance.get("/all-attribute");
      // console.log("attr", data);
      setAttr(data.Attribute);
    } catch (error) {
      console.error("Error fetching attributes:", error);
    }
  };

  // Function to handle checkbox selection
  const handleCheckboxChange = (event) => {
    const { value, checked } = event.target;
    // console.log('valuevaluevalue', value)
    setSelectedFilters((prevState) => {
      // If checked, add the value to selectedFilters, otherwise remove it
      if (checked) {
        return { ...prevState, [value]: checked };
      } else {
        const { [value]: removedValue, ...rest } = prevState;
        return rest;
      }
    });

    // console.log('selectedFilters', selectedFilters)
    setCurrentPage(1);
  };

  const removeFilter = ({ key, val }) => {
    const value = `${key},${val}`;
    setSelectedFilters((prevState) => {
      const { [value]: removedValue, ...rest } = prevState;
      return rest;
    });

    setCurrentPage(1); // Set current page to 1
  };




  const generateQueryString = () => {
    const filterObj = {};

    // Construct filter object from selected filters
    Object.entries(selectedFilters).forEach(([key, value]) => {
      const [attrKey, attrValue] = key.split(",");

      // Check if attribute key already exists in filter object
      if (filterObj[attrKey]) {
        // Append to existing attribute value if key exists
        filterObj[attrKey] += `,${attrValue}`;
      } else {
        // Create new attribute if key doesn't exist
        filterObj[attrKey] = attrValue;
      }
    });

    // Convert filter object to JSON string
    const filterString = JSON.stringify(filterObj);

    // console.log(filterString); // Output the generated filter string
    setViewfillter(filterString)
    setTimeout(function () { getCategory(filterString, currentPage, selectedRanges); }, 100);
  };

  // const handleCategoryLinkClick = (categoryId) => {
  //   getCategory(fillter, currentPage, selectedRanges);
  // };

  useEffect(() => {
    generateQueryString(); // Call generateQueryString when selectedFilters change
    getRating();
    setIsCat(true); // Set loading state to true
    getAttribute();
    // getCategory(fillter,currentPage,selectedRanges);
  }, [id, currentPage, selectedFilters, selectedRanges, count]); // Empty dependency array ensures that the effect runs once after the initial render

  useEffect(() => {
    setSelectedRanges([]);
  }, [id]); // Empty dependency array ensures that the effect runs once after the initial render

  // useEffect(() => {
  //   generateQueryString(); // Call generateQueryString when selectedFilters change
  // }, [selectedFilters,selectedRanges]); // Add selectedFilters as a dependency

  // Function to filter products based on selected attributes

  const [priceRange, setPriceRange] = useState({ min: 0, max: 100 });

  function handleChange(e) {
    setPriceRange({
      priceRange,
      [e.target.name]: parseInt(e.target.value),
    });
  }


  const handlePageChange = (page) => {
    setCurrentPage(page);
  };



  // Calculate the maximum sale price to determine the range
  const maxSalePrice = Math.max(...products.map(product => product.salePrice));

  // Determine the number of ranges based on the maximum sale price
  const numRanges = Math.ceil(maxSalePrice / 10000);

  // Generate price ranges dynamically
  const priceRanges = Array.from({ length: numRanges }, (_, index) => ({
    min: index * 10000,
    max: (index + 1) * 10000,
  }));

  // Filter out the price ranges that match the actual sale prices of your products
  const filteredPriceRanges = priceRanges.filter(range =>
    products.some(product =>
      product.salePrice >= range.min && product.salePrice < range.max
    )
  );

  const handleCheckpriceboxChange = (event) => {
    const { value, checked } = event.target;
    if (checked) {
      setSelectedRanges([...selectedRanges, value]);
    } else {
      setSelectedRanges(selectedRanges.filter(range => range !== value));
    }
    setCurrentPage(1);
    // console.log(selectedRanges)
  };



  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const isVideo = (url) => /\.(mp4|webm|ogg)$/i.test(url);

  return (
    <>




      <Header />
      <main className="page-content  mypadding bg-light overflow-auto pb-4 px-0" >


        <div className="container">



          <div className=" px-3 py-2">

            <section className="mt-2">
              {CatImage !== undefined && CatImage !== '' ? (<>
                <img src={CatImage} width={'100%'} className="rounded" style={{ aspectRatio: "5/1", objectFit: "cover" }} />
              </>) : (
                <div className=" skeleton w-100" style={{ height: 100 }} />
              )}

            </section>

            <div className="bg-white p-0 position-relative mt-3  " onMouseEnter={handleMouseEnter}
              onMouseLeave={handleMouseLeave} style={{ zIndex: 2 }} >
              <Swiper
                slidesPerView={1}
                spaceBetween={12}
                pagination={false}
                navigation={false}
                breakpoints={{
                  300: {
                    slidesPerView: 2.8,
                  },
                  640: {
                    slidesPerView: 2.8,
                  },
                  768: {
                    slidesPerView: 2.8,
                  },
                  1024: {
                    slidesPerView: 3.2,
                  },
                }}
                ref={swiperRefLocal}
                autoplay={{
                  delay: 1000,
                  pauseOnMouseEnter: true,
                }}
                loop={true}
                modules={[Pagination, Navigation, Autoplay]} className="book-now pb-0 ">

                {isCat
                  ? Array.from({ length: 4 }).map((_, index) => (
                    <SwiperSlide
                      className="skeleton"
                      style={{
                        width: "100%",
                        aspectRatio: "179/222",
                      }}
                    ></SwiperSlide>
                  ))
                  : (
                    <>


                      {Cat.map((category, index) => (


                        <SwiperSlide key={index} >
                          <Link to={`/${category?.slug}`} className="border rounded text-center d-block pb-3 pt-2"  >
                            <img
                              src={category?.image}
                              className="img-fluid d-block p-4 w-100"
                              alt="img"
                              style={{ aspectRatio: '1/1' }}
                            />
                            <p className="m-0"> {category?.title} </p>
                          </Link>
                        </SwiperSlide>

                      ))}


                    </>
                  )}


              </Swiper>
            </div>


            {CatImage !== undefined && CatImage !== '' ? (<>
              <section className="d-flex px-2 py-1 rounded mt-3 border g-4 align-items-center me-3 ">
                <div className="col">
                  <div className="row g-2 ">
                    <label
                      htmlFor="sorting"
                      className="col-auto col-form-label "
                    >
                      No of products
                    </label>
                    <div className="col-auto">
                      <select className="form-select" id="sorting" value={count} onChange={handlecountChange} >
                        <option value="50">50</option>
                        <option value="100">100</option>

                        <option value="200">200</option>

                        <option value="500">500</option>

                      </select>
                    </div>
                  </div>
                </div>
              </section>
            </>) : (
              <div className=" skeleton w-100 mt-3" style={{ height: 40 }} />
            )}


            <div className="row pt-4 mx-n2 mb-4 ">
              {isCat
                ? Array.from({ length: 6 }).map((_, index) => (
                  <div
                    key={index}
                    className="col-6 mt-4"
                  >
                    <div
                      className="card-1 skeleton"
                      style={{ height: 300, borderRadius: 5 }}
                    ></div>

                  </div>
                ))
                : Pro.map((Pro) => {
                  // Calculate average rating for the current product
                  const productRatings = ratings.filter(rating => rating.productId === Pro._id);
                  const totalRatings = productRatings.length;
                  const totalRatingValue = productRatings.reduce((acc, curr) => acc + curr.rating, 0);
                  const averageRating = totalRatings > 0 ? totalRatingValue / totalRatings : 0;

                  return (
                    <>

                      {/* Product Card */}
                      <div className="col-md-4 col-6 mb-4">


                        <div className="shop-card">
                          <div className="dz-media media-overlay">
                            <div className="dz-media media-overlay">
                              {isVideo(Pro.pImage) ? (
                                <video
                                  src={Pro.pImage}
                                  autoPlay
                                  muted
                                  loop
                                  playsInline
                                  className="img-fluid w-100"
                                  style={{ objectFit: "cover" }}
                                />
                              ) : (
                                <img
                                  className="img-fluid"
                                  src={Pro.pImage}
                                  alt={`${Pro.title} Product Image`}
                                />
                              )}
                            </div>

                            <div className="shop-meta">
                              <Link
                                to={`/product/${Pro.slug}`}
                                className="btn btn-secondary btn-icon"

                              >
                                <i className="fa-solid fa-eye d-md-none d-block" />
                                <span className="d-md-block d-none">Quick View</span>
                              </Link>
                              <div className="btn btn-primary meta-icon dz-carticon">
                                <svg
                                  width={24}
                                  height={24}
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M20.531 5.47097L17.531 2.47097C17.238 2.17797 16.763 2.17797 16.47 2.47097C16.177 2.76397 16.177 3.23897 16.47 3.53197L18.19 5.25197H6.00098C4.48398 5.25197 3.25098 6.48497 3.25098 8.00197V11.001C3.25098 11.415 3.58698 11.751 4.00098 11.751C4.41498 11.751 4.75098 11.415 4.75098 11.001V8.00197C4.75098 7.31297 5.31198 6.75197 6.00098 6.75197H18.19L16.47 8.47197C16.177 8.76497 16.177 9.23997 16.47 9.53297C16.616 9.67897 16.808 9.75297 17 9.75297C17.192 9.75297 17.384 9.67997 17.53 9.53297L20.53 6.53297C20.823 6.23997 20.823 5.76497 20.53 5.47197L20.531 5.47097Z"
                                    fill="black"
                                  />
                                  <path
                                    d="M18.9998 12.25C18.5858 12.25 18.2498 12.586 18.2498 13V15.999C18.2498 16.688 17.6888 17.249 16.9998 17.249H5.81075L7.53075 15.529C7.82375 15.236 7.82375 14.761 7.53075 14.468C7.23775 14.175 6.76275 14.175 6.46975 14.468L3.46975 17.468C3.17675 17.761 3.17675 18.236 3.46975 18.529L6.46975 21.529C6.61575 21.675 6.80775 21.749 6.99975 21.749C7.19175 21.749 7.38375 21.676 7.52975 21.529C7.82275 21.236 7.82275 20.761 7.52975 20.468L5.80975 18.748H16.9988C18.5158 18.748 19.7488 17.515 19.7488 15.998V12.999C19.7488 12.585 19.4128 12.249 18.9988 12.249L18.9998 12.25Z"
                                    fill="black"
                                  />
                                </svg>
                              </div>
                            </div>
                          </div>
                          <div className="dz-content">
                            <h5 className="title">
                              <Link to={`/product/${Pro.slug}`} >{Pro.title}</Link>
                            </h5>
                            <h6 className="price">
                              ₹{Pro.salePrice} {' '}
                              <del>₹{Pro.regularPrice}{" "}</del>
                            </h6>
                            <div className="shop-cart-btn">
                              <Link to={`/product/${Pro.slug}`}>
                                <svg
                                  width={24}
                                  height={24}
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M21 9.24995H18.401L14.624 3.58395C14.394 3.23895 13.927 3.14495 13.584 3.37595C13.239 3.60595 13.146 4.07095 13.376 4.41595L16.599 9.24995H7.401L10.624 4.41595C10.854 4.07095 10.761 3.60595 10.416 3.37595C10.071 3.14595 9.606 3.23895 9.376 3.58395L5.599 9.24995H3C2.586 9.24995 2.25 9.58595 2.25 9.99995C2.25 10.4139 2.586 10.7499 3 10.7499H3.385L4.943 18.5389C5.199 19.8199 6.333 20.7499 7.64 20.7499H16.361C17.668 20.7499 18.801 19.8199 19.058 18.5389L20.616 10.7499H21.001C21.415 10.7499 21.751 10.4139 21.751 9.99995C21.751 9.58595 21.414 9.24995 21 9.24995ZM17.586 18.245C17.469 18.827 16.954 19.2499 16.36 19.2499H7.64C7.046 19.2499 6.531 18.827 6.414 18.245L4.915 10.7499H19.085L17.586 18.245Z"
                                    fill="white"
                                  />
                                  <path
                                    d="M14.75 14V16C14.75 16.414 14.414 16.75 14 16.75C13.586 16.75 13.25 16.414 13.25 16V14C13.25 13.586 13.586 13.25 14 13.25C14.414 13.25 14.75 13.586 14.75 14ZM10 13.25C9.586 13.25 9.25 13.586 9.25 14V16C9.25 16.414 9.586 16.75 10 16.75C10.414 16.75 10.75 16.414 10.75 16V14C10.75 13.586 10.414 13.25 10 13.25Z"
                                    fill="white"
                                  />
                                </svg>
                              </Link>
                            </div>
                          </div>
                          <div className="product-tag">
                            {/* <span className="badge-1">Get 20% Off</span> */}
                            <Link to={`/product/${Pro.slug}`} className="badge-heart">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width={20}
                                height={20}
                                viewBox="0 0 20 20"
                                fill="none"
                              >
                                <path
                                  d="M17.3666 3.84172C16.941 3.41589 16.4356 3.0781 15.8794 2.84763C15.3232 2.61716 14.727 2.49854 14.1249 2.49854C13.5229 2.49854 12.9267 2.61716 12.3705 2.84763C11.8143 3.0781 11.3089 3.41589 10.8833 3.84172L9.99994 4.72506L9.1166 3.84172C8.25686 2.98198 7.0908 2.49898 5.87494 2.49898C4.65907 2.49898 3.49301 2.98198 2.63327 3.84172C1.77353 4.70147 1.29053 5.86753 1.29053 7.08339C1.29053 8.29925 1.77353 9.46531 2.63327 10.3251L3.5166 11.2084L9.99994 17.6917L16.4833 11.2084L17.3666 10.3251C17.7924 9.89943 18.1302 9.39407 18.3607 8.83785C18.5912 8.28164 18.7098 7.68546 18.7098 7.08339C18.7098 6.48132 18.5912 5.88514 18.3607 5.32893C18.1302 4.77271 17.7924 4.26735 17.3666 3.84172Z"
                                  stroke="black"
                                  strokeWidth="1.5"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                              </svg>
                            </Link>
                          </div>
                        </div>


                      </div>


                    </>
                  );
                })}

              {Pro.length === 0 && !isCat && (
                <div
                  className="container mx-auto my-2 mt-5 py-2 bg-white text-center"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",

                  }}
                >
                  <div>

                    <img src="/assets/img/product-not-found.png" alt="no product" className="d-block mx-auto mb-3" style={{ maxWidth: 200 }} />
                    <p>No products found for this category.</p>
                  </div>
                </div>

              )}

              <hr className="d-none d-sm-block" />

              <div className="d-flex justify-content-between mt-6">
                <ul className="pagination">
                  <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                    <button className="page-link" type="button" onClick={() => handlePageChange(currentPage - 1)}><i className="ri-arrow-left-s-line me-1"></i>Prev</button>
                  </li>
                </ul>

                <ul className="pagination">
                  <li className={`page-item ${totalPages === 0 ? 'disabled' : ''}`}>
                    <button className="page-link" type="button" onClick={() => handlePageChange(currentPage + 1)} aria-label="Next">Next<i className="ms-1 ri-arrow-right-s-line"></i></button>
                  </li>
                </ul>
              </div>


              {/* Pagination */}
            </div>


          </div>

        </div>

      </main>

      <Footer />

    </>
  );
};

export default Category;
